import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CAR_SETVICE_ID, CLEANING_SETVICE_ID } from "../../lib/variables";
import { getServiceSubCategories } from "../../services/categoriesFn";
import SerivceTabsSkeleton from "./../skeletons/ServiceSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { setSubServiceId } from "../../lib/redux/slices/subServiceId";

const CategoryNav = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeSubService, setActiveSubService] = useState();
  const [allServices, setAllServices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  useEffect(() => {
    if (location.pathname === "/cleaning-services") {
      fetchServiceById(CLEANING_SETVICE_ID);
    } else {
      fetchServiceById(CAR_SETVICE_ID);
    }
  }, [location.pathname]);

  const fetchServiceById = async (id) => {
    try {
      setIsLoading(true);
      const response = await getServiceSubCategories(id);
      if (response.data.status === "success") {
        let data = response.data.data;
        setAllServices(data);
        setActiveSubService(data[0] || "");
        dispatch(setSubServiceId(data[0]?._id || null));
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleCategoryClick = (event, newValue) => {
    setActiveSubService(newValue);
    dispatch(setSubServiceId(newValue._id || null));
  };

  if (isLoading) {
    return (
      <Box position="relative" width="100%" mt={2}>
        <SerivceTabsSkeleton />
      </Box>
    );
  }

  if (allServices.length === 0 && isLoading === false) {
    return (
      <Box
        p={3}
        display={"flex"}
        justifyContent={"center"}
        color={"text.secondary"}
      >
        <Typography>No services available for this category</Typography>
      </Box>
    );
  }

  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      width={{ xs: "100%", sm: "95%" }}
      overflow={"hidden"}
      margin="0px auto"
      mt={0.8}
    >
      <Tabs
        value={activeSubService}
        onChange={handleCategoryClick}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          "& .MuiTabs-indicator": { backgroundColor: "primary" },
          "& .MuiButtonBase-root.MuiTabScrollButton-root": {
            color: "primary",
          },
        }}
      >
        {allServices.map((category) => (
          <Tab
            key={category._id}
            value={category}
            label={
              <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
                gap={0.6}
                sx={{
                  "& img": {
                    transition: "filter 0.3s ease-in-out",
                    filter:
                      activeSubService._id === category._id
                        ? "brightness(0) saturate(100%) invert(12%) sepia(83%) saturate(7448%) hue-rotate(270deg) brightness(90%) contrast(97%)" // Purple Color
                        : "none",
                  },
                  "&:hover img": {
                    filter:
                      "brightness(0) saturate(100%) invert(12%) sepia(83%) saturate(7448%) hue-rotate(270deg) brightness(90%) contrast(97%)", // Purple on Hover
                  },
                  "&.MuiBox-root:hover": {
                    "& .MuiTypography-root": {
                      color: "#7922D8",
                    },
                  },
                }}
              >
                <img
                  src={category.activeIcon}
                  alt={category.name[currentLanguage]}
                  style={{
                    width: 30,
                    height: 30,
                    objectFit: "cover",
                    borderRadius: 4,
                  }}
                />
                <Typography
                  fontSize="0.75rem"
                  fontWeight={activeSubService._id === category._id ? 600 : 500}
                  textTransform="capitalize"
                  color={
                    activeSubService._id === category._id
                      ? "primary"
                      : "text.secondary"
                  }
                >
                  {category.name[currentLanguage]}
                </Typography>
              </Box>
            }
            sx={{
              minWidth: "auto",
              padding: "6px 12px",
              color:
                activeSubService._id === category.name
                  ? "primary"
                  : "text.primary",
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default CategoryNav;
